import {
  ActivateCanceledSubscriptionPaymentData,
  PaymentData,
  UpgradeFreeTrialPaymentData,
} from '../models/PaymentData';
import {
  SubscribeRequestDto,
  ActivateTrialSubscriptionRequestDto,
} from '../models/PaymentDTO';

export function toSubscribeRequestDTO({
  purchaseIntentId,
  quantity,
  priceId,
  promotionCode,
  taxId,
  taxType,
  formData,
  paymentType,
  companyName,
}: PaymentData): SubscribeRequestDto {
  if (
    purchaseIntentId === undefined ||
    quantity === null ||
    priceId === null ||
    formData === undefined
  ) {
    throw new Error();
  }

  const customerTax =
    taxId !== ''
      ? {
          type: taxType,
          value: taxId,
        }
      : undefined;

  return {
    purchaseIntentId,
    customer: {
      name: companyName,
      taxId: customerTax,
      address: {
        city: formData.address.city,
        country: formData.address.country,
        line1: formData.address.line1,
        line2: formData.address.line2 ?? '',
        postalCode: formData.address.postal_code,
      },
    },
    product: {
      priceId,
      quantity,
      promotionCode: promotionCode,
    },
    paymentType: paymentType,
  };
}

export function toAddActiveSubscriptionDataRequestDTO({
  quantity,
  priceId,
  promotionCode,
  taxId,
  taxType,
  formData,
  companyName,
  paymentType,
}: UpgradeFreeTrialPaymentData): ActivateTrialSubscriptionRequestDto {
  if (priceId === null || formData === undefined) {
    throw new Error();
  }

  const customerTax =
    taxId !== ''
      ? {
          type: taxType,
          value: taxId,
        }
      : undefined;

  return {
    customer: {
      name: companyName,
      taxId: customerTax,
      address: {
        city: formData.address.city,
        country: formData.address.country,
        line1: formData.address.line1,
        line2: formData.address.line2 ?? '',
        postalCode: formData.address.postal_code,
      },
    },
    product: {
      priceId,
      quantity,
      promotionCode: promotionCode,
    },
    paymentType: paymentType,
  };
}

export function toActivateTrialSubscriptionRequestDTO({
  quantity,
  priceId,
  promotionCode,
  taxId,
  taxType,
  formData,
  companyName,
  paymentType,
}: ActivateCanceledSubscriptionPaymentData): ActivateTrialSubscriptionRequestDto {
  if (priceId === null || formData === undefined) {
    throw new Error();
  }

  const customerTax =
    taxId !== ''
      ? {
          type: taxType,
          value: taxId,
        }
      : undefined;

  return {
    customer: {
      name: companyName,
      taxId: customerTax,
      address: {
        city: formData.address.city,
        country: formData.address.country,
        line1: formData.address.line1,
        line2: formData.address.line2 ?? '',
        postalCode: formData.address.postal_code,
      },
    },
    product: {
      priceId,
      quantity,
      promotionCode: promotionCode,
    },
    paymentType: paymentType,
  };
}
